module.exports = __webpack_public_path__ + "img/sit_man.7fad29a3.png";